import { useEffect, useState } from 'react';

/**
 * RD-SEC-015 — true while the tab/PWA is backgrounded (`document.hidden`).
 * Drives the recovery-codes step's blur-while-backgrounded veil (flow H): iOS
 * takes an app-switcher snapshot the instant the app leaves the foreground,
 * so the grid must already be blurred by the time that snapshot is taken —
 * `visibilitychange` fires synchronously enough for this, `pagehide`/
 * `pageshow` cover the PWA-suspend edge cases `visibilitychange` alone can miss.
 */
export default function useHiddenWhileBackgrounded() {
  const [hidden, setHidden] = useState(
    typeof document !== 'undefined' && document.visibilityState === 'hidden',
  );

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const markHidden = () => setHidden(true);
    const syncFromVisibilityState = () => setHidden(document.visibilityState === 'hidden');
    document.addEventListener('visibilitychange', syncFromVisibilityState);
    window.addEventListener('pagehide', markHidden);
    window.addEventListener('pageshow', syncFromVisibilityState);
    return () => {
      document.removeEventListener('visibilitychange', syncFromVisibilityState);
      window.removeEventListener('pagehide', markHidden);
      window.removeEventListener('pageshow', syncFromVisibilityState);
    };
  }, []);

  return hidden;
}
